import { CSSProperties, FC, ReactNode } from 'react';

interface IAccordianProps {
  title: string;
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const Accordion: FC<IAccordianProps> = ({
  title,
  isOpen,
  children,
  className,
  style,
}) => {
  return (
    <details open={isOpen} className={className} style={style}>
      <summary>
        <h2>{title}</h2>
      </summary>
      {children}
    </details>
  );
};

export default Accordion;
